import React, { useEffect } from "react"
import "../css/diversity-new-skin.css"

const RenderParaQuestions = (props) => {
  const {
    id,
    form,
    index,
    sentence,
    choiceSet,
    formValues,
    paraAnswers,
    handleChange,
    setParaAnswers,
  } = props;

  useEffect(() => {
    if (!paraAnswers[index]) {
      if (!formValues?.[id]?.trim())
        setParaAnswers(choiceSet?.edges?.[0]?.node?.label?.split(".").map(ele => ele.trim()))
      else
        setParaAnswers(formValues[id].split(".").map(ele => ele.trim()))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) 

  return (
    <div
      style={{
        width: '100%',
        minHeight: '70px',
        position: 'relative',
        marginTop: '8px',
        marginBottom: '24px',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <div className="para-question-label" style={{ paddingBottom: "10px" }}>
        <label htmlFor={id} style={{ fontWeight: 500 }}>{index + 1}. {sentence}</label>
      </div>
            <textarea
         rows={3}
         autoComplete="off"
         spellCheck={false}
         data-gramm="false"
         data-gramm_editor="false"
         data-enable-grammarly="false"
         className="fitb-input para-textarea"
         value={paraAnswers[index] || ''}
         onChange={(e) => {
           const newParaAnswers = [...paraAnswers];
           newParaAnswers[index] = e.target.value.replace(/\./g, "");
           setParaAnswers([...newParaAnswers]);
           form.setFieldsValue({ [id]: newParaAnswers.join(". ").trim() });
           handleChange(false);
         }}
         onBlur={(e) => {
           const newParaAnswers = [...paraAnswers];
           newParaAnswers[index] = e.target.value.trim().replace(/\./g, "");
           setParaAnswers([...newParaAnswers]);
           form.setFieldsValue({ [id]: newParaAnswers.join(". ").trim() });
           handleChange(false);
         }}
         onCopy={(e) => e.preventDefault()}
         onPaste={(e) => e.preventDefault()}
         onCut={(e) => e.preventDefault()}
         onContextMenu={(e) => e.preventDefault()}
         onKeyDown={(e) => {
           // tab block to stop autocorrect triger
           if (e.key === 'Tab') {
             e.preventDefault();
             return false;
           }
           
           if ((e.ctrlKey || e.metaKey) && (
             e.key === 'c' || e.key === 'C' ||
             e.key === 'v' || e.key === 'V' ||
             e.key === 'x' || e.key === 'X' ||
             e.key === 'a' || e.key === 'A'
           )) {
             e.preventDefault();
             return false;
           }
         }}
         style={{
           width: '100%',
           minHeight: '80px',
           padding: '8px 12px',
           border: '1px solid #d9d9d9',
           borderRadius: '4px',
           background: 'white !important',
           fontFamily: 'inherit',
           fontSize: '14px',
           lineHeight: '1.5',
           textAlign: 'left',
           verticalAlign: 'top',
           resize: 'vertical',
           textDecoration: 'none !important',
           borderBottom: '1px solid #d9d9d9 !important'
         }}
       />
    </div>)
}

export default RenderParaQuestions;
